export const POLL_INTERVAL = 60000
